import { getLang } from '@/helpers/getLang'
import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type MegaschoolRelease = {
    id: number
    title: string
    image: string
    author: {
        name: string
        post: string
        photo: string
    }
    authorId: number
    position: number
    video: string
    enableToView?: boolean
}

export type MegaschoolReleaseDto = {
    title: string
    image: string
    author: any
    // authorId: number
    position: number
    video: string
}

export const MegaschoolReleasesApi = createApi({
    reducerPath: 'MegaschoolReleasesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ['MEGASCHOOL-RELEASE'],
    endpoints: builder => ({
        getMegaschoolRelease: builder.query<MegaschoolRelease, { id: number }>({
            query: id => ({ url: `/megaschool-releases/${id}` }),
            providesTags: ['MEGASCHOOL-RELEASE']
        }),
        getAllMegaschoolReleases: builder.query<MegaschoolRelease[], void>({
            query: () => ({ url: `/megaschool-releases?lang=${getLang()}` }),
            providesTags: ['MEGASCHOOL-RELEASE']
        }),
        getAllMegaschoolReleasesEn: builder.query<MegaschoolRelease[], void>({
            query: () => ({ url: `/megaschool-releases?lang=en` }),
            providesTags: ['MEGASCHOOL-RELEASE']
        }),
        createMegaschoolRelease: builder.mutation<any, MegaschoolReleaseDto>({
            query: data => ({ url: `/megaschool-releases`, method: 'POST', body: data }),
            invalidatesTags: ['MEGASCHOOL-RELEASE']
        }),
        deleteMegaschoolReleasesByIds: builder.mutation<any, any>({
            query: data => ({ url: `/megaschool-releases/delete-by-ids`, method: 'POST', body: data }),
            invalidatesTags: ['MEGASCHOOL-RELEASE']
        }),
        updateMegaschoolRelease: builder.mutation<any, any>({
            query: data => ({ url: `/megaschool-releases/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ['MEGASCHOOL-RELEASE']
        }),
        updateMegaschoolReleaseEn: builder.mutation<any, any>({
            query: data => ({ url: `/megaschool-releases/en/update/${data.id}`, method: 'PATCH', body: {title: data.title} }),
            invalidatesTags: ["MEGASCHOOL-RELEASE"]
        }),
        toggleEnableToViewMegaschoolRelease: builder.mutation<any, { id: number }>({
            query: data => ({ url: '/megaschool-releases/enable-to-view', method: 'POST', body: data }),
            invalidatesTags: ['MEGASCHOOL-RELEASE']
        }),
        toggleEnableToViewByListMegaschoolRelease: builder.mutation<any, { ids: number[]; enable?: boolean }>({
            query: data => ({ url: '/megaschool-releases/enable-to-view/list', method: 'POST', body: data }),
            invalidatesTags: ['MEGASCHOOL-RELEASE']
        }),
    })
})

export const {
    useGetMegaschoolReleaseQuery,
    useGetAllMegaschoolReleasesQuery,
    useGetAllMegaschoolReleasesEnQuery,
    useCreateMegaschoolReleaseMutation,
    useDeleteMegaschoolReleasesByIdsMutation,
    useUpdateMegaschoolReleaseMutation,
    useUpdateMegaschoolReleaseEnMutation,
    useToggleEnableToViewByListMegaschoolReleaseMutation,
    useToggleEnableToViewMegaschoolReleaseMutation
} = MegaschoolReleasesApi
